import ModelUtil from '@leverege/model-util';
import { ns } from '@leverege/i18n';
const TYPE = 'graph.background.striped';
const {
  t
} = ns('ui-attributes-graphs.models.StripedGraphBackgrounModel');
function create() {
  return {
    type: TYPE,
    backgroundColor: null,
    stripeColor: null,
    stripeWidth: 1,
    orientation: ['diagonal']
  };
}
export default {
  create,
  TYPE,
  get name() {
    return t('name');
  },
  ...ModelUtil.createAllValue('backgroundColor'),
  ...ModelUtil.createAllValue('orientation'),
  ...ModelUtil.createAllValue('stripeColor'),
  ...ModelUtil.createAllValue('stripeWidth')
};